import { ChangeEvent } from 'react';
import { If } from '~/components';
import { Container, Label, StyledCheckbox } from './styles';

export interface RoundedCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  name?: string;
  disabled?: boolean;
  className?: string;
}

const RoundedCheckbox = ({
  checked,
  onChange,
  label,
  name,
  disabled = false,
  className,
}: RoundedCheckboxProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <Container className={className}>
      <StyledCheckbox
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        name={name}
        disabled={disabled}
      />
      <If condition={!!label}>
        <Label>{label}</Label>
      </If>
    </Container>
  );
};

export default RoundedCheckbox;
